import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

function Terms() {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1 className="page-title">Terms of Service</h1>
        <p className="intro-text">
          These Terms govern your use of Apna Soundbox, an app for Indian merchants to receive instant voice notifications for incoming UPI payments.
        </p>

        <div className="content-section">
          <h2 className="section-title">Use of Service</h2>
          <ul className="content-list">
            <li>You agree to use Apna Soundbox in compliance with applicable laws and UPI/payment provider policies.</li>
            <li>Apna Soundbox provides notifications based on payment messages/notifications available on your device. We do not process or initiate transactions.</li>
            <li>You are responsible for verifying actual payment settlement in your bank/UPI app where required.</li>
          </ul>
        </div>

        <div className="content-section">
          <h2 className="section-title">Accounts</h2>
          <ul className="content-list">
            <li>You may be required to sign in (e.g., with Google/Firebase). Keep your credentials secure.</li>
            <li>We may suspend or terminate access for abuse, non-compliance, or security reasons.</li>
          </ul>
        </div>

        <div className="content-section">
          <h2 className="section-title">Subscriptions / Payments</h2>
          <ul className="content-list">
            <li>Certain features may be paid. Prices and features may change with notice.</li>
            <li>Third-party payment processors (e.g., Razorpay) terms apply to transactions.</li>
          </ul>
        </div>

        <div className="content-section">
          <h2 className="section-title">Disclaimer</h2>
          <p>
            Apna Soundbox is provided "as is" without warranties. We aim for high reliability but cannot guarantee uninterrupted or error-free operation. You acknowledge that you should confirm critical payments in your bank/UPI app.
          </p>
        </div>

        <div className="content-section">
          <h2 className="section-title">Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, we are not liable for indirect, incidental, special, or consequential damages arising from your use of Apna Soundbox.
          </p>
        </div>

        <div className="content-section">
          <h2 className="section-title">Changes</h2>
          <p>
            We may update these Terms from time to time. Continued use indicates acceptance of the updated Terms.
          </p>
        </div>

        <div className="content-section">
          <h2 className="section-title">Contact</h2>
          <p>
            For questions, contact <a href="mailto:support@apnasoundbox.com">support@apnasoundbox.com</a>.
          </p>
        </div>

        <div className="back-link">
          <Link to="/">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default Terms;
